import api, { apiNoLoading, IDataRequest, IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import AProvider from "src/framework/providers/AProvider";
import { ListagemFinanceirasOutput, SimulacaoFinanciamentoInput, SimulacaoFinanciamentoOutput } from "./types";

class FinanciamentoProvider extends AProvider {
    constructor() {
        super("/projetos/financiamentos");
    }

    async listarFinanceiras(): Promise<ListagemFinanceirasOutput | null>  {
        const request: IDataRequest = { url: `${this.path}/financeiras` }
        const response: IDataResponse<ListagemFinanceirasOutput> = await apiNoLoading.get(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data
        }
        return null
    }

    async simularFinanciamento(payload: SimulacaoFinanciamentoInput ): Promise<SimulacaoFinanciamentoOutput | null> {
        const request: IDataRequest = { url: `${this.path}/simulacao`, data: payload }
        const response: IDataResponse<SimulacaoFinanciamentoOutput> = await api.post(request);
        if (response.statusCode === STATUS_CODE.OK) {
            return response.data
        }
        return null
    }
}

export { FinanciamentoProvider }